module.exports = __webpack_public_path__ + "static/favicon-5e5321e1605f94912b8be9294b936beb.png";